query GetSageGiftAccountRecords(
  $page: Int
  $limit: Int
  $filters: [SageGiftAccountFilterConditionInput!]
  $sortBy: String
) {
  sageGiftAccountRecords(
    page: $page
    limit: $limit
    filters: $filters
    sortBy: $sortBy
  ) {
    collection {
      id
      name
      lastSageSyncDate
      sageId
      sageName
      status
      type
      syncTransactions
      sageClass
      sageCurrency
      sageDepartment
      sageLocation
      openDifferenceCount
      fundAccount {
        id
        currency
        sageCode
        fund {
          id
          name
          legalEntity {
            id
            name
          }
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
